import { ReactElement } from "react";

import VippsButton from "./VippsLoginButton.svg?react";

export default function VippsLoginButton(): ReactElement {
    return <VippsButton />;
}
